import { useAllFeatureFlags, useFeatureFlagValue, FeatureFlag } from "../../feature-flags";

/**
 * Gate for the onboarding portal.
 *
 * `isLoaded` distinguishes "flag not yet delivered by LaunchDarkly" from
 * "flag is off", so the route guard can avoid flashing a redirect before flags
 * resolve (see `OnboardingLayout`).
 */
export function useOnboardingEnabled() {
  const flags = useAllFeatureFlags();
  const isEnabled = useFeatureFlagValue(FeatureFlag.EnableOnboarding);
  const isLoaded = FeatureFlag.EnableOnboarding.flag in flags;

  return { isEnabled, isLoaded };
}
